import { Box, Button, Card, CardContent, CardHeader, Grid2, Typography } from '@mui/material';
import { Outlet } from 'react-router-dom';

export default function CourseStudio() {
  return (
    <Outlet />
  );
}